/** True when the app runs with offline fixtures (no waybee-api / LoopBack). */
export default function isClassDiaryDemo() {
  const v = process.env.REACT_APP_CLASS_DIARY_DEMO;
  return v === "1" || v === "true";
}
